import { ReactElement } from "react";
import dynamic from "next/dynamic";

import MintLayout from "../../components/Layouts/Mint";
import SEO from "../../components/Seo/Seo";

const CaucusMint = dynamic(
  () => import("../../components/CaucusMint/CaucusMint"),
  {
    ssr: false
  }
);

const Caucus = () => (
  <>
    <SEO title="Caucus Mint | Coinage Media" />
    <CaucusMint />
  </>
);

Caucus.getLayout = function getLayout(page: ReactElement) {
  return <MintLayout hideMenu>{page}</MintLayout>;
};

export default Caucus;
